import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import SignIn from '../components/Signin';
import Signup from '../components/Signup';
import EmailOrMobileVerify from '../components/EmailOrMobileVerify';
import OtpVerify from '../components/OtpVerify';
import ResetPassword from '../components/ResetPassword';
import ResetSuccess from '../components/ResetSuccess';
import MobileOtpVerification from '../components/MobileOtpVerification';
import EmailOtpVerification from '../components/EmailOtpVerification';
import Password from '../components/Password';
import Login from '../components/Login';
import Toast from '../components/toast/Toast';
import { getAppConfig } from '../api/app_config';
import { getTenantName } from '../utility/utility';
import {
  RESTRICTED_SIGNUP_TENANTS,
  SIGNUP_RESTRICTED_MESSAGE,
} from '../utility/constant';

// Signup is allowed per backend `signup_allowed` (elevo_onboarding_enabled feature flag).
// Falls back to the restricted tenant list if the field is missing or the call fails.
const SignupGuard = ({ children }) => {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(null);
  useEffect(() => {
    const fallback = !RESTRICTED_SIGNUP_TENANTS.includes(getTenantName());
    getAppConfig()
      .then((res) => {
        const value = res?.data?.signup_allowed;
        setAllowed(typeof value === 'boolean' ? value : fallback);
      })
      .catch(() => setAllowed(fallback));
  }, []);
  useEffect(() => {
    if (allowed === false) {
      Toast.error(SIGNUP_RESTRICTED_MESSAGE);
      navigate('/');
    }
    // eslint-disable-next-line
  }, [allowed]);
  return allowed ? children : null;
};

const Routers = () => {
  return (
    <Routes>
      <Route path='/' element={<Login />} />
      <Route
        path='/signup'
        element={
          <SignupGuard>
            <SignIn />
          </SignupGuard>
        }
      />
      <Route path='/emailormobileverify' element={<EmailOrMobileVerify />} />
      <Route path='/otpverify' element={<OtpVerify />} />
      <Route path='/resetpassword' element={<ResetPassword />} />
      <Route path='/resetsuccess' element={<ResetSuccess />} />
      <Route path='/mobile/otp/verify' element={<MobileOtpVerification />} />
      <Route path='/email/otp/verify' element={<EmailOtpVerification />} />
      <Route path='/signin/password' element={<Password />} />
      <Route path='/signin/register' element={<Signup />} />
    </Routes>
  );
};
export default Routers;
